import React from "react";
import Topnavbar from "../components/navbar";
import ProductList from "../components/products";

const Products = () => {
  return (
    <div className="Home">
      <Topnavbar />
      <h2>Products list page..</h2>
      <ProductList />
    
    </div>
  );
};

export default Products;
